var $cache = {};
var dialog = require('_core_ext/dialog')

function initializeError() {
    $cache.document = $(document);
    $cache.paymentError = $cache.document.find('.js-payment-error');

    $cache.document.on('click', '.js-close-payment-error', function() {
        dialog.close();
    });

    if ($cache.paymentError.length) {
        dialog.open({
            html: $cache.paymentError.children().first().html(),
            options: {
                dialogClass: 'b-checkout_dialog m-error'
            }
        });
    }
}
exports.initError = function () {
    initializeError();
}